import React,{useEffect} from "react";
import {
    Navigate, 
    useNavigate
} from 'react-router-dom';
import { toast } from 'react-toastify';
// style
import 'react-toastify/dist/ReactToastify.css';
// api
import { logout } from "../../api/auth";
import { removeUserSession} from '../../utils/common';

const Logout = ({lang}) => {
    
    let history = useNavigate();

    useEffect(() => {
        let customId = 'logout';
        
        removeUserSession();

        logout().then(function (response) {
            removeUserSession();
            toast.success(lang.bye, {
                toastId: customId,
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                pauseOnFocusLoss: false,
                closeOnClick: true,
                pauseOnHover: false
            });

        }).catch(function (error) {
            // console.log("error", error);
            removeUserSession();
            history("/")
        })
        // disable the eslint rule
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
   
    return (<Navigate to="/" replace={true} />)
};

export default Logout;